'use client';
export { List, ListItem, ListIcon, OrderedList, UnorderedList } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map